import { Rocket } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function EmptyState() {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-16">
        <div className="rounded-full bg-muted p-4 mb-6">
          <Rocket className="h-12 w-12 text-muted-foreground" />
        </div>

        <p className="text-muted-foreground text-center max-w-md mb-6">
          Deploy your first application from the command line:
        </p>

        <div className="bg-muted rounded-lg px-6 py-3 font-mono text-sm">
          <span className="text-muted-foreground">$ </span>
          <span>rbt cloud up --help</span>
        </div>
      </CardContent>
    </Card>
  );
}
